import { Question } from 'pages/user/features/question/Question';

export const QuestionRoute = () => <Question />;
